import { render, staticRenderFns } from "./CategoryList.vue?vue&type=template&id=506dba6f"
var script = {}
import style0 from "./CategoryList.vue?vue&type=style&index=0&id=506dba6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ControllerProductCategories: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerProductCategories.js').default})
